module.exports = __webpack_public_path__ + "assets/images/TTD1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/TTD1.png
// module id = 1432
// module chunks = 1